import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import { ApiEndpointService } from '../services/api-endpoint.service';

export enum WebPageOpenGraphResponseStatus {
  success,
  invalidUrl,
  cannotGetPage,
  cannotGetImage,
  fileSizeExceeded,
  storageQuotaExceeded,
  cannotSaveImage
}

export interface IWebPageOpenGraphImageDetails {
  FileName: string;
  FileId: string;
  ImageType: string;
  ImageUrl: string;
  ImageWidth: number;
  ImageHeight: number;
  ImageAltText: string;
}

export interface IWebPageOpenGraphData extends IWebPageOpenGraphImageDetails {
  Status: WebPageOpenGraphResponseStatus;
  Title: string;
  Description: string;
  Link: string;
}

@Injectable()
export class WebPageContentApi {
  constructor(private httpService: HttpService, private apiEndpoint: ApiEndpointService) {}

  getWebPageContentData(webPageUrl: string): Observable<IWebPageOpenGraphData> {
    //we use post here since we need to pass a url that could be large and to avoid encoding the url to the query string(url within a url)
    return this.httpService.post({ webPageUrl }, this.apiEndpoint.WebPageContentUrl);
  }

}
